import {
  POST_SURVEY_DESTINATION,
  POST_SURVEY_DESTINATION_ROUTE,
} from "@/domains/surveys/models/constants";
import type { PostSurveyDestination } from "@/domains/surveys/models/types";

/** Where the loading bar is headed. `undefined` is the check still running, which is the care plan. */
export const selectPostSurveyRoute = (destination: PostSurveyDestination | undefined) => {
  return POST_SURVEY_DESTINATION_ROUTE[destination ?? POST_SURVEY_DESTINATION.CAREPLAN];
};
